import React, { useEffect, useState, useCallback } from "react";
import { getAsistenciasDocente, registrarEntradaAsistencia, registrarSalidaAsistencia } from "../../../services/asistenciadocente.service";
import { getAllDocentes } from "../../../services/docente.service";
import { useSelector } from "react-redux";

export const MisAsistencias = () => {
  const [asistencias, setAsistencias] = useState([]);
  const [loading, setLoading] = useState(false);
  const user = useSelector((state) => state.auth?.user || state.usuario?.user || state.usuario);
  
  // States para el formulario
  const [nombreGrupo, setNombreGrupo] = useState("");
  const [fotoEntrada, setFotoEntrada] = useState(null);
  const [fotoSalida, setFotoSalida] = useState(null);
  const [detalle, setDetalle] = useState("");

  const [idDocente, setIdDocente] = useState(null);

  const cargarDocente = useCallback(async () => {
    try {
      const docentesData = await getAllDocentes();
      const docenteInfo = docentesData.find((doc) => doc.usuario.username === user?.username);
      if (docenteInfo?.docente?.idDocente) {
        setIdDocente(docenteInfo.docente.idDocente);
      }
    } catch (err) {
      console.log(err);
    }
  }, [user]);

  useEffect(() => {
    cargarDocente();
  }, [cargarDocente]);

  const cargarAsistencias = useCallback(async () => {
    if (!idDocente) return;
    try {
      const data = await getAsistenciasDocente(idDocente);
      setAsistencias(data);
    } catch (err) {
      console.log(err);
    }
  }, [idDocente]);

  useEffect(() => {
    if (idDocente) cargarAsistencias();
  }, [idDocente, cargarAsistencias]);

  const asistenciaActiva = asistencias.find((a) => a.estado === "En Curso");

  const handeEntradaSubmit = async (e) => {
    e.preventDefault();
    if (!fotoEntrada || !nombreGrupo) {
      alert("Completar campos obligatorios.");
      return;
    }
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("IdDocente", idDocente);
      formData.append("NombreGrupo", nombreGrupo);
      formData.append("FotoEntrada", fotoEntrada);

      await registrarEntradaAsistencia(formData);
      setFotoEntrada(null);
      setNombreGrupo("");
      cargarAsistencias();
    } catch (err) {
      alert(err.message || "Error al marcar entrada");
    } finally {
      setLoading(false);
    }
  };

  const handleSalidaSubmit = async (e) => {
    e.preventDefault();
    if (!fotoSalida || !asistenciaActiva) return;
    
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("IdAsistencia", asistenciaActiva.idAsistencia);
      formData.append("FotoSalida", fotoSalida);
      if (detalle) formData.append("DetalleDocente", detalle);

      await registrarSalidaAsistencia(formData);
      setFotoSalida(null);
      setDetalle("");
      cargarAsistencias();
    } catch (err) {
      alert(err.message || "Error al marcar salida");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 w-full min-h-screen bg-slate-50 grid grid-cols-1 md:grid-cols-12 gap-6">
      
      {/* Columna Izquierda: Panel de Control (4 cols) */}
      <div className="md:col-span-4 flex flex-col gap-6">
        <div className="bg-white rounded-2xl shadow-sm border border-slate-100 overflow-hidden">
          <div className="bg-blue-600 p-6 text-white">
            <h2 className="text-xl font-bold">Control de Asistencia</h2>
            <p className="text-blue-100 text-sm mt-1">Registra tu horario en tiempo real</p>
          </div>
          
          <div className="p-6">
            {!asistenciaActiva ? (
              <form onSubmit={handeEntradaSubmit} className="flex flex-col gap-4">
                <div>
                  <label className="block text-sm font-semibold text-slate-700 mb-1">Nombre del Grupo/Módulo</label>
                  <input
                    type="text"
                    required
                    placeholder="Ej. Grupo de Inglés Avanzado"
                    value={nombreGrupo}
                    onChange={(e) => setNombreGrupo(e.target.value)}
                    className="w-full rounded-xl border-slate-200 py-3 focus:ring-blue-500 focus:border-blue-500 bg-slate-50"
                  />
                </div>
                <div>
                  <label className="block text-sm font-semibold text-slate-700 mb-1">Captura de Entrada (Evidencia)</label>
                  <label className="flex flex-col items-center justify-center w-full h-32 border-2 border-slate-300 border-dashed rounded-xl cursor-pointer bg-slate-50 hover:bg-slate-100 overflow-hidden relative">
                    {fotoEntrada ? (
                      <img 
                        src={URL.createObjectURL(fotoEntrada)} 
                        alt="Previsualización" 
                        className="w-full h-full object-cover"
                      />
                    ) : (
                      <div className="flex flex-col items-center justify-center pt-5 pb-6">
                        <svg className="w-8 h-8 mb-3 text-slate-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
                        </svg>
                        <p className="text-sm text-slate-500 font-semibold">Toca o haz clic para tomar foto</p>
                      </div>
                    )}
                    <input
                      type="file"
                      accept="image/*"
                      capture="environment"
                      required
                      onChange={(e) => setFotoEntrada(e.target.files[0])}
                      className="hidden"
                    />
                  </label>
                  {fotoEntrada && (
                    <button type="button" onClick={() => setFotoEntrada(null)} className="mt-2 text-xs text-red-500 font-medium hover:underline">
                      Quitar imagen seleccionada
                    </button>
                  )}
                </div>
                <button
                  type="submit"
                  disabled={loading}
                  className="mt-2 w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-3.5 rounded-xl transition-all shadow-sm shadow-blue-200"
                >
                  {loading ? "Marcando..." : "Marcar Entrada"}
                </button>
              </form>
            ) : (
              <form onSubmit={handleSalidaSubmit} className="flex flex-col gap-4">
                <div className="p-4 bg-yellow-50 border border-yellow-100 rounded-xl mb-2">
                  <p className="text-sm text-yellow-800 font-medium">Clase en Curso</p>
                  <p className="font-bold text-yellow-900">{asistenciaActiva.nombreGrupo}</p>
                  <p className="text-xs text-yellow-700 mt-1">Entrada: {new Date(asistenciaActiva.horaEntrada).toLocaleTimeString()}</p>
                </div>

                <div>
                  <label className="block text-sm font-semibold text-slate-700 mb-1">Captura de Salida (Evidencia)</label>
                  <label className="flex flex-col items-center justify-center w-full h-32 border-2 border-slate-300 border-dashed rounded-xl cursor-pointer bg-yellow-50 hover:bg-yellow-100 overflow-hidden relative">
                    {fotoSalida ? (
                      <img 
                        src={URL.createObjectURL(fotoSalida)} 
                        alt="Previsualización Salida" 
                        className="w-full h-full object-cover"
                      />
                    ) : (
                      <div className="flex flex-col items-center justify-center pt-5 pb-6">
                        <svg className="w-8 h-8 mb-3 text-yellow-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
                        </svg>
                        <p className="text-sm text-yellow-700 font-semibold">Toca o haz clic para tomar foto</p>
                      </div>
                    )}
                    <input
                      type="file"
                      accept="image/*"
                      capture="environment"
                      required
                      onChange={(e) => setFotoSalida(e.target.files[0])}
                      className="hidden"
                    />
                  </label>
                  {fotoSalida && (
                    <button type="button" onClick={() => setFotoSalida(null)} className="mt-2 text-xs text-red-500 font-medium hover:underline">
                      Quitar imagen seleccionada
                    </button>
                  )}
                </div>
                <div>
                  <label className="block text-sm font-semibold text-slate-700 mb-1">Detalles o Notas (Opcional)</label>
                  <textarea
                    rows="2"
                    placeholder="Descripción de lo avanzado u observaciones..."
                    value={detalle}
                    onChange={(e) => setDetalle(e.target.value)}
                    className="w-full rounded-xl border-slate-200 py-3 focus:ring-yellow-500 focus:border-yellow-500 bg-slate-50 text-sm"
                  ></textarea>
                </div>
                <button
                  type="submit"
                  disabled={loading}
                  className="mt-2 w-full bg-yellow-500 hover:bg-yellow-600 text-white font-bold py-3.5 rounded-xl transition-all shadow-sm shadow-yellow-200"
                >
                  {loading ? "Marcando..." : "Finalizar Clase y Marcar Salida"}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>

      {/* Columna Derecha: Historial (8 cols) */}
      <div className="md:col-span-8">
        <div className="bg-white rounded-2xl shadow-sm border border-slate-100 p-6 min-h-full flex flex-col">
          <h2 className="text-xl font-bold text-slate-800 mb-6 flex items-center gap-2">
            Historial de Asistencias
          </h2>
          
          <div className="flex-1 overflow-x-auto">
            <table className="w-full text-sm text-left whitespace-nowrap">
              <thead className="bg-slate-50/50 text-slate-500 font-medium border-b border-t">
                <tr>
                  <th className="px-5 py-3">Fecha</th>
                  <th className="px-5 py-3">Grupo</th>
                  <th className="px-5 py-3">Horario</th>
                  <th className="px-5 py-3 text-center">Horas Hrs.</th>
                  <th className="px-5 py-3 text-center">Estado</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100">
                {asistencias.map((a) => (
                  <tr key={a.idAsistencia} className="hover:bg-slate-50/50 transition-colors">
                    <td className="px-5 py-4 font-medium text-slate-700">
                      {new Date(a.fecha).toLocaleDateString()}
                    </td>
                    <td className="px-5 py-4 text-slate-600">
                      <div className="max-w-[200px] truncate" title={a.nombreGrupo}>{a.nombreGrupo}</div>
                    </td>
                    <td className="px-5 py-4 text-slate-500">
                      <span className="text-green-600 font-medium">{new Date(a.horaEntrada).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}</span>
                      {" - "}
                      {a.horaSalida ? (
                        <span className="text-red-500 font-medium">{new Date(a.horaSalida).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}</span>
                      ) : (
                        <span className="text-slate-400 italic">Cursando</span>
                      )}
                    </td>
                    <td className="px-5 py-4 text-center text-slate-700 font-medium">
                      {a.horasTrabajadas ?? "-"}
                    </td>
                    <td className="px-5 py-4 text-center">
                       <span className={`px-2.5 py-1 rounded-lg text-[11px] font-bold uppercase tracking-wide
                        ${a.estado === 'Pendiente' ? 'bg-yellow-50 text-yellow-600 border border-yellow-200' :
                          a.estado === 'En Curso' ? 'bg-slate-100 text-slate-600 border border-slate-200' :
                          a.estado === 'Aprobada' ? 'bg-green-50 text-green-600 border border-green-200' :
                          a.estado === 'Observada' ? 'bg-red-50 text-red-600 border border-red-200' :
                          'bg-blue-50 text-blue-600 border border-blue-200'}`}>
                        {a.estado}
                      </span>
                    </td>
                  </tr>
                ))}
                {asistencias.length === 0 && (
                  <tr>
                    <td colSpan="5" className="px-5 py-12 text-center">
                      <div className="flex flex-col items-center justify-center text-slate-400">
                        <svg className="w-12 h-12 mb-3 text-slate-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        <p>No tienes registros de asistencia aún.</p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      
    </div>
  );
};
